import React, { useMemo } from 'react'
import { History } from './History'
import { ProbabilityChange } from './ProbabilityChange'
import { Card, CardLayout, CheckUpLink, Container, Divisor, Title } from './styles'
import { defaultCheckUpRequestParams } from '~/constants/checkUp'
import { usePatient } from '~/context'
import { useFetchCheckUpProperties } from '~/hooks/useFetchCheckUpProperties'
import { ECheckUpPropertyTypes } from '~/interfaces'
import { message } from '~/services'
import { Inline } from '~/styles'
import { ANALYTICAL_MODELS_PATH, DEFAULT_PATH } from '~/constants'
import { IconComponent } from '~/assets/icons/component'

export const MetabolicSyndromeSummary = (): JSX.Element => {
  const { patient } = usePatient()
  const { data: properties } = useFetchCheckUpProperties({
    pathParams: { patientId: patient.id },
    queryParams: defaultCheckUpRequestParams
  })

  const metabolicSyndromeHistory = useMemo(
    () => properties?.filter(property => property.type === ECheckUpPropertyTypes.METABOLIC_SYNDROME).reverse(),
    [properties]
  )

  if (metabolicSyndromeHistory) {
    const getLastMeasurement = () => metabolicSyndromeHistory[metabolicSyndromeHistory.length - 1]
    const simulationResult = metabolicSyndromeHistory.find(checkup => checkup.simulationResult)?.simulationResult

    return (
      <Container>
        <Inline width="100%" justifyContent="space-between">
          <Title>{message('analyticalModels.metabolic_syndrome_title')}</Title>

          <CheckUpLink
            to={`/${DEFAULT_PATH}/${ANALYTICAL_MODELS_PATH}/${patient.medicalRecord}`}
            state="metabolicSyndrome"
          >
            Ver detalhes
            <IconComponent iconsize={11} name="externalLink" />
          </CheckUpLink>
        </Inline>

        <Card>
          <CardLayout>
            <ProbabilityChange probability={simulationResult ?? 0} year={getLastMeasurement().date} />
            <Divisor />
            <History measurements={metabolicSyndromeHistory} />
          </CardLayout>
        </Card>
      </Container>
    )
  }

  return <></>
}
